import { useMemo } from 'react';

import { ConsumerBackerIntent } from '@givebacks/api/backer';

import { IntentTextData } from '../../types/onboarding';

const ACCOUNT_ACTION_LABELS: Record<string, { text: string; boldWord: string }> = {
  view_membership_card: { text: 'Access your membership card', boldWord: 'membership card' },
  view_event_tickets: { text: 'Access your event tickets', boldWord: 'event tickets' },
};

const CAUSE_ACTION_LABELS: Record<string, { text: string; boldWord: string }> = {
  buy_a_membership: { text: 'Buy a membership', boldWord: 'membership' },
  support_a_fundraiser: { text: 'Support a fundraiser', boldWord: 'fundraiser' },
  buy_a_store_item: { text: 'Buy a store item', boldWord: 'store item' },
  buy_a_ticket: { text: 'Buy a ticket', boldWord: 'ticket' },
  make_a_donation: { text: 'Make a donation', boldWord: 'donation' },
};

/**
 * Provides structured text data for components to render
 */
export const useIntentTextData = (fetchedIntents: ConsumerBackerIntent): IntentTextData => {
  const account = useMemo(() => {
    const selectedActions = Object.entries(ACCOUNT_ACTION_LABELS)
      .filter(([key]) => key in fetchedIntents && fetchedIntents[key])
      .map(([, config]) => config);

    return {
      selectedActions,
    };
  }, [fetchedIntents]);
  const causeActions = useMemo(() => {
    const selectedActions = Object.entries(CAUSE_ACTION_LABELS)
      .filter(([key]) => key in fetchedIntents && fetchedIntents[key])
      .map(([, config]) => config)
      .slice(0, 2);

    const totalSelected = Object.keys(CAUSE_ACTION_LABELS).filter(
      (key) => fetchedIntents[key]
    ).length;

    return {
      selectedActions,
      hasMore: totalSelected > 2,
    };
  }, [fetchedIntents]);
  return useMemo(
    (): IntentTextData => ({
      account,
      causeActions,
    }),
    [account, causeActions]
  );
};
